export default "__VITE_ASSET__15f030d6__"